import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FiGlobe, FiZap } from "react-icons/fi";

import api from "@/services/api";
import useStore from "@/services/store";
import Loader from "@/components/loader";

export default function Onboard() {
  const { organization } = useStore();
  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  async function generate() {
    if (!organization?._id) return;
    let target = url.trim();
    if (!target) return;
    if (!/^https?:\/\//i.test(target)) target = `https://${target}`;

    const t0 = Date.now();
    console.log("[brain/onboard] submit", { organization_id: organization._id, url: target });
    try {
      setLoading(true);
      const res = await api.post("/brain/onboard/generate", {
        organization_id: organization._id,
        organization_name: organization.name,
        url: target,
      });
      console.log("[brain/onboard] response", { ms: Date.now() - t0, ok: res?.ok, code: res?.code, message: res?.message, pages: res?.data?.length });
      if (!res.ok) throw new Error(res.message ? `${res.code || "error"}: ${res.message}` : res.code || "Generation failed");
      toast.success("Brain generated");
      navigate("/recruiter/brain/files");
    } catch (e) {
      console.error("[brain/onboard] failed", e);
      toast.error(e.message || "Generation failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-2xl mx-auto p-8">
      <div className="text-center mb-8">
        <div className="w-14 h-14 rounded-2xl border-2 border-black bg-white flex items-center justify-center mx-auto mb-5 shadow-[4px_4px_0_0_rgba(0,0,0,1)]">
          <FiZap className="w-6 h-6 text-gray-700" />
        </div>
        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Add your website</h1>
        <p className="text-sm text-gray-500 max-w-md mx-auto">
          We'll read your site and draft the 5 SELF pages — culture, ideal candidate, process, tone, offer.
        </p>
      </div>

      <div className="border-2 border-black rounded-xl p-5 bg-white shadow-[4px_4px_0_0_rgba(0,0,0,1)]">
        <label className="block text-xs font-extrabold uppercase tracking-widest text-gray-500 mb-2">
          Website URL
        </label>
        <div className="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2.5 bg-white">
          <FiGlobe className="w-4 h-4 text-gray-400 shrink-0" />
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !loading && generate()}
            placeholder="https://yourcompany.com/careers"
            disabled={loading}
            className="flex-1 text-sm bg-transparent focus:outline-none disabled:opacity-50"
          />
        </div>

        <div className="mt-5 flex items-center gap-3">
          <button
            onClick={generate}
            disabled={loading || !url.trim()}
            className="btn btn-primary btn-small disabled:opacity-50 disabled:cursor-not-allowed">
            {loading ? (
              <>
                <Loader size="small" color="white" />
                Generating…
              </>
            ) : (
              "Generate brain"
            )}
          </button>
          <p className="text-xs text-gray-500">Takes 5–15 seconds. Overwrites your 5 SELF pages.</p>
        </div>
      </div>

      <button
        onClick={() => navigate("/recruiter/brain/files")}
        className="mt-6 mx-auto block text-sm text-gray-500 hover:text-gray-900">
        ← Back to brain
      </button>
    </div>
  );
}
